import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IResponseData } from '../../interfaces/response-data';
import { IUnitGroup } from '../../interfaces/unit-group';
import { Router } from '@angular/router';
import { DateService } from '../date-service/date.service';
import { BookingParamsService } from '../booking-params/booking-params.service';
import { IBookingParams } from '../../interfaces/booking-params';

@Injectable({
  providedIn: 'root'
})
export class PropertyParamsService {
  observable: Observable<string | IResponseData<IUnitGroup>>;
  language: string | null = null;

  constructor(
    private readonly bookingParamsService: BookingParamsService,
    public router: Router,
    public dateService: DateService
  ) {}

  createPropertiesListingParams(
    cityId: number,
    selectedDates?: Date[],
    rooms?: number,
    guests?: number,
    childrenAges?: string,
    propertyId?: number
  ) {
    const params = {} as IBookingParams;

    params.city = cityId;

    if (selectedDates) {
      params['checkin'] = this.dateService.formatDateForQuery(selectedDates[0]);
      params['checkout'] = this.dateService.formatDateForQuery(selectedDates[1]);
    }
    if (rooms) {
      params['rooms'] = rooms;
    }
    if (guests) {
      params['guests'] = guests;
    }
    if (childrenAges) {
      params['childrenAges'] = childrenAges;
    }
    if (propertyId) {
      params['property'] = propertyId;
    }

    return params;
  }

  redirectToPropertiesListing({
    route,
    selectedDates,
    rooms,
    guests,
    childrenAges,
    cityId,
    propertyId,
    useLocationChange = false
  }: {
    route: string;
    selectedDates: Date[];
    rooms: number;
    guests: number;
    childrenAges: string;
    cityId: number;
    propertyId?: number;
    useLocationChange?: boolean;
  }): void {
    const urlParams = this.createPropertiesListingParams(
      cityId,
      selectedDates,
      rooms,
      guests,
      childrenAges,
      propertyId
    );
    if (useLocationChange) {
      const urlSearchParams = new URLSearchParams(Object.entries(urlParams));
      document.location.href = `${route}?${urlSearchParams.toString()}`;
      return;
    }

    this.router.navigate([route], {
      queryParams: urlParams,
      queryParamsHandling: 'merge'
    });
    this.bookingParamsService.dispatchAddBookingParams(urlParams);
  }

  sendParamsToStore(cityId: number) {
    const params = this.createPropertiesListingParams(cityId, null, null, null);
    this.bookingParamsService.dispatchAddBookingParams(params);
  }
}
